// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".demand-all[data-v-27dd1c1a]{height:700px;margin-top:20px;overflow-y:auto;overflow-x:hidden}", ""]);
// Exports
module.exports = exports;
